/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react'
import { toast } from 'react-toastify'
import SendEmailIcon from '@mui/icons-material/ForwardToInbox'
import { LoadingButton } from '@mui/lab'
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography
} from '@mui/material'
import { useMutation } from '@tanstack/react-query'
import TerminatedAPI from 'api/faber/TerminatedAPI'
import OrbitSession from 'hooks/useCookies'

function SendEmailToAllTerminatedCustomersButton({
  refetchAllUsers
}: ISendEmailProps) {
  const faberToken = OrbitSession.get('faberToken')

  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)

  const { mutate: sendEmailToAllUsers, isLoading: isSendingEmailLoading } =
    useMutation(TerminatedAPI.sendEmailToAllUsers, {
      onSuccess: (res) => {
        if (
          res.data.message ===
          'No terminated user with email sent count 0 is found'
        ) {
          toast.error(
            'Emails have already been sent out previously to all users. Please send an email to the individual user instead.'
          )
          handleConfirmDialogClose()
        } else {
          toast.success(
            `Successfully sent email to ${res.data.data.emailsUpdated} Users`
          )
          refetchAllUsers()
          handleConfirmDialogClose()
        }
      },
      onError: () => {
        toast.error(
          'There was an error in sending out the emails, please try again'
        )
      }
    })

  const handleSendEmailsToAllUsers = () => {
    sendEmailToAllUsers(faberToken)
  }

  const handleConfirmDialogOpen = () => {
    setConfirmDialogOpen(true)
  }
  const handleConfirmDialogClose = () => {
    setConfirmDialogOpen(false)
  }
  return (
    <>
      <Stack alignItems='flex-start'>
        <LoadingButton
          variant='contained'
          component='label'
          sx={{ fontSize: '12px', p: 3 }}
          startIcon={<SendEmailIcon />}
          onClick={handleConfirmDialogOpen}
        >
          Send email to all users
        </LoadingButton>
      </Stack>
      <Dialog
        open={confirmDialogOpen}
        onClose={handleConfirmDialogClose}
        sx={{ minWidth: '800px' }}
      >
        <DialogTitle>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mb: '-15px',
              mt: '-5px'
            }}
          >
            <Typography
              sx={{
                color: 'black',
                fontSize: '18px',
                fontWeight: '700'
              }}
            >
              Email confirmation
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ p: 2 }}>
            Are you sure you want to send the{' '}
            <em>Update account details email</em> to <strong>all</strong> Faber
            users who have terminated their line with Circles?
          </Typography>
          <Alert severity='info'>
            Please note that this email will only be sent out to users who have
            not receieved any prior <em>Update account details emails</em> from
            us
          </Alert>
          <Alert severity='warning'>
            Please ensure that all users had their numbers terminated with
            Circles.Life
          </Alert>
          <Stack
            justifyContent={'space-between'}
            flexDirection={'row'}
            sx={{ mx: 17, mt: 5 }}
          >
            <Button onClick={handleConfirmDialogClose}>Cancel</Button>
            <LoadingButton
              variant='contained'
              component='label'
              onClick={handleSendEmailsToAllUsers}
              loading={isSendingEmailLoading}
              loadingIndicator={<CircularProgress />}
            >
              Confirm
            </LoadingButton>
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default SendEmailToAllTerminatedCustomersButton

interface ISendEmailProps {
  refetchAllUsers: () => void
}
